import React from 'react';
import Channels from '../components/Channels';
import Teams from '../components/Teams';
import Header from '../components/Header';
import SendMessage from '../components/SendMessage';
import AppLayout from '../components/AppLayout';
import Messages from '../components/Messages';
import Sidebar from '../containers/Sidebar';
import { graphql } from '@apollo/client/react/hoc';
import gql from 'graphql-tag';
import _ from 'lodash';
import {Redirect} from 'react-router-dom';
import Messenger from '../containers/Messenger';

const ViewTeam=({data:{loading,me},match:{params:{teamId,channelId}}})=>{
    if(loading){
        return null;
    }
    const {username,teams}=me;

    if(!teams.length){
        return (<Redirect to="/create-team" />);
    }

    let teamIdInteger=parseInt(teamId,10);
    const teamIdx=teamIdInteger?_.findIndex(teams,['id',teamIdInteger]):0;
    const team=teamIdx===-1?teams[0]:teams[teamIdx];

    const channelIdInteger=parseInt(channelId,10);
    const channelIndx=channelIdInteger?_.findIndex(team.channels,['id',channelIdInteger]):0;
    const channel=channelIndx===-1?team.channels[0]:team.channels[channelIndx];

    return (
    <AppLayout>
        <Sidebar teams={teams.map(team=>({
                id:team.id,
                letter:team.name.charAt(0).toUpperCase(),
            }))} 
            team={team}
            username={username} />
        <Header channelName={channel.name}/>
        <Messenger channelId={channel.id} username={username} />
        <SendMessage channelName={channel.name} channelId={channel.id}/>
    </AppLayout>
    );
};
const allTeamsQuery=gql`
{
    me{
        id
        username
        teams{
            id
            name
            admin
            channels{
                id
                name
            }
        }
    }
}
`;
export default graphql(allTeamsQuery,{options:{fetchPolicy:'network-only'}})(ViewTeam);